<script lang="ts" module>
	import { cn, tv } from 'tailwind-variants'

	export const navigationMenuTriggerStyle = tv({
		base: 'rounded-lg px-2.5 py-1.5 text-sm font-medium transition-all hover:bg-muted focus:bg-muted focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-1 disabled:opacity-50 data-popup-open:bg-muted/50 data-popup-open:hover:bg-muted data-open:bg-muted/50 data-open:hover:bg-muted data-open:focus:bg-muted group/navigation-menu-trigger inline-flex h-9 w-max items-center justify-center outline-none disabled:pointer-events-none',
	})
</script>

<script lang="ts">
	import ChevronDown from '@lucide/svelte/icons/chevron-down'
	import { NavigationMenu as NavigationMenuPrimitive } from 'bits-ui'

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: NavigationMenuPrimitive.TriggerProps = $props()
</script>

<NavigationMenuPrimitive.Trigger
	class={cn(navigationMenuTriggerStyle(), 'group', className)}
	data-slot="navigation-menu-trigger"
	bind:ref
	{...restProps}
>
	{@render children?.()}
	<ChevronDown
		class="relative top-px ml-1 size-3 transition duration-300 group-data-open/navigation-menu-trigger:rotate-180 group-data-popup-open/navigation-menu-trigger:rotate-180"
		aria-hidden="true"
	/>
</NavigationMenuPrimitive.Trigger>
